module.exports = __webpack_public_path__ + "static/media/logo-abbiamo.fd8de5d1.svg";